const SITE_SUFFIX = 'Portfolio Evaluation and Stock Advisory Tool';

const ROUTE_TITLES = {
  home: 'Home',
  dashboard: 'Dashboard',
  evaluation: 'Evaluate Portfolio',
  newevaluation: 'New Evaluation',
  msievaluation: 'Evaluate Portfolio',
  preevaluation: 'Pre-Evaluation',
  login: 'Login',
  register: 'Sign Up',
  forgotpassword: 'Forgot Password',
  about: 'History',
  contactus: 'Contact Us',
  privacypolicy: 'Privacy Policy',
  legalagreement: 'Legal Agreement',
  marketsmithindia: 'MarketSmith India',
  plandetails: 'Pricing',
  plandetailsnew: 'Pricing',
  faqs: "FAQ's",
  sitemap: 'Sitemap',
  reports: 'Reports',
  account: 'My Account',
  useraccount: 'My Profile',
  more: 'More',
  psiverify: 'Verify Account',
  adminregister: 'Register Client',
  partnerbrokeradmin: 'Partner Broker Admin',
  paymentredirect: 'Payment',
  paymentfailure: 'Payment Failed',
  paymentsuccess: 'Payment Successful',
  paymenterror: 'Payment Error',
  paymentcomplete: 'Payment Complete',
};

export function getPageTitle(route) {
  const routeName = route && route.name;
  let pageTitle = ROUTE_TITLES[routeName];

  if (routeName === 'login' && route.params && route.params.id === 'signup') {
    pageTitle = 'Sign Up';
  } else if (routeName === 'login') {
    pageTitle = 'Login';
  }

  if (!pageTitle) {
    return `PortfolioSmith - ${SITE_SUFFIX}`;
  }

  return `PortfolioSmith - ${pageTitle} | ${SITE_SUFFIX}`;
}

export function setDocumentTitle(route) {
  document.title = getPageTitle(route);
}



// WEBPACK FOOTER //
// ./src/utils/pageTitles.js